import { useMemo } from 'react';
import { Text } from '@mercator-gcp/grout';
import type { ProjectSize } from 'types';

type TProps = {
  minTotalUnits?: ProjectSize['total_units_min'];
  maxTotalUnits?: ProjectSize['total_units_max'];
};

const NumberOfUnits = ({ minTotalUnits, maxTotalUnits }: TProps) => {
  const label = useMemo(() => {
    if (minTotalUnits === maxTotalUnits) {
      if (maxTotalUnits === 1) {
        return `${maxTotalUnits} unit`;
      }

      return `${maxTotalUnits} units`;
    }

    return `${minTotalUnits} - ${maxTotalUnits} units`;
  }, [minTotalUnits, maxTotalUnits]);

  return <Text>{label}</Text>;
};

export default NumberOfUnits;
